export default __webpack_public_path__ + "static/image040-1682f59aa3c8981e4394e0efddc518fc.jpg";